import { render, staticRenderFns } from "./ChangePasswordModal.vue?vue&type=template&id=48b822f1&"
import script from "./ChangePasswordModal.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48b822f1')) {
      api.createRecord('48b822f1', component.options)
    } else {
      api.reload('48b822f1', component.options)
    }
    module.hot.accept("./ChangePasswordModal.vue?vue&type=template&id=48b822f1&", function () {
      api.rerender('48b822f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Ftp/ChangePasswordModal.vue"
export default component.exports